import { render, staticRenderFns } from "./NoshiPreview.vue?vue&type=template&id=66d2e9fa&scoped=true&lang=pug&"
import script from "./NoshiPreview.vue?vue&type=script&lang=ts&"
export * from "./NoshiPreview.vue?vue&type=script&lang=ts&"
import style0 from "./NoshiPreview.vue?vue&type=style&index=0&id=66d2e9fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d2e9fa",
  null
  
)

export default component.exports